<template>
  <b-modal id="share-modal" centered ok-title="Condividi" :title="title" size="lg" @ok="ok">
    <b-form>
      <b-form-group>
        <label style="font-size: large" class="pb-1" for="shareSelect">Scegli un utente con cui condividere:</label>
        <multiselect group-label="label" group-values="options" placeholder="Seleziona con chi condividere" track-by="text" label="text"
          id="shareSelect" v-model="selected" :options="groupList" :multiple="true"/>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="notify" v-model="notify" class="mt-1" name="checkbox-1">
          Invia notifica Mail
        </b-form-checkbox>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
} from 'bootstrap-vue'
import objectsRepository from '@/api/objectsRepository'
import authRepository from '@/api/authRepository'
import useMyStore from '@/services/useMyStore'
import { capitalizeFirstLetter } from 'vue2-leaflet'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Modal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    Multiselect
  },
  props: {
    files: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const { currentObject } = useMyStore()
    return { currentObject }
  },
  data() {
    return {
      title: 'Condividi',
      data: [],
      groupList: [],
      selected: null,
      recursive: false,
      notify: true,
    }
  },
  watch: {
    currentObject: {
      handler(val) {
        const file = this.files.find(el => el.id === val)
        this.title = `Condividi ${file ? file.label : ''}`
        this.recursive = file.is_folder
      },
      deep: true,
    },
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      this.$emit('loading', true)
      const { data } = await authRepository.list()
      data.data.forEach(a => {
        if (a.blocked_at === null) {
          this.groupList.push({
            value: a.id,
            text: capitalizeFirstLetter(a.name),
            role: a.profile.label,
          })
        }
      })
      this.groupList = [
        {
          label: 'Utenti Esterni',
          options: this.groupList.filter(el => el.role === 'external'),
        },
        {
          label: 'Utenti Interni',
          options: this.groupList.filter(el => el.role !== 'external'),
        },
      ]
    },
    async ok() {
      if (this.currentObject === 0) {
        return
      }
      
      const userIds = this.selected.map((el) => el.value)

      this.data = []
      const param = {
        userIds: userIds,
        recursive: this.recursive,
        objectId: this.currentObject,
        notify: this.notify,
      }
      await objectsRepository.setPermission(param)
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
